import { Policy } from '@/lib/App';

export const PolicyName = {
  DEFAULT: 'default',
  ADMIN: 'admin',
  EDITOR: 'editor',
  PUBLISHER: 'publisher',
  TECH_SUPPORT: 'tech_support',

  EXPERIMENT_COUNCIL: 'experiment_council',
  EXPERIMENT_MODERATOR: 'experiment_moderator',
  ROLLOUT_MODERATOR: 'rollout_moderator',
  MODERATOR: 'moderator',
};

export const blacklistedPolicyNames = [
  PolicyName.DEFAULT,
  PolicyName.MODERATOR,
  PolicyName.PUBLISHER,
  PolicyName.EXPERIMENT_COUNCIL,
];

export const columnOrderByPolicyName = {
  [PolicyName.EDITOR]: 1,
  [PolicyName.ROLLOUT_MODERATOR]: 2,
  [PolicyName.EXPERIMENT_MODERATOR]: 3,
  [PolicyName.PUBLISHER]: 4,
  [PolicyName.TECH_SUPPORT]: 5,
  [PolicyName.ADMIN]: 6,
  [PolicyName.EXPERIMENT_COUNCIL]: 7,
};

export const additionalPolicies: Policy[] = [
  {
    id: 0,
    policyName: 'tech_support',
    policyDesc: 'Tech Support',
  },
];
